
import "../CreateClient/CreateClient.css";
import React, { useEffect } from "react";
import { useGlobalContext } from "../../context";
import { radioType } from "../../interfaces";

type propsData = {
    address: string,
    setAddress: (address: string) => void,
    activeIncludeAddress: boolean,
    setActiveIncludeAddress: (newActiveIncludeAddress: boolean) => void,
    client: any
}

function Address(props: propsData) {

    const { includeAddresses, setIncludeAddresses } = useGlobalContext();
    const { address, setAddress, setActiveIncludeAddress, client } = props;

    useEffect(() => {
        if (client) {
            setAddress(client.address);
            setIncludeAddresses((includeAddresses: radioType[]) => {
                if (client.includeAddressOnBranding) {
                    return includeAddresses.map((item:radioType) => item.title === "Yes" ? { ...item, active: true } : { ...item, active: false });
                }
                else {
                    return includeAddresses.map((item:radioType) => item.title === "No" ? { ...item, active: true } : { ...item, active: false });
                }
            });
        }
    }, [client]);

    const handleChange = (item: radioType): void => {
        setIncludeAddresses((includeAddresses: radioType[]) => includeAddresses.map((ancAdrs: radioType) => ancAdrs.id === item.id ? { ...ancAdrs, active: true } : { ...ancAdrs, active: false }));
    }

    useEffect(() => {
        const active: radioType | undefined = includeAddresses.find((item:radioType) => item.active);
        if (active?.title === "Yes") {
            setActiveIncludeAddress(true);
        }
        else {
            setActiveIncludeAddress(false);
        }
    }, [includeAddresses]);

    return(
        <div className = "Address">
            <div className = "createClient-form-type mrg-btm">
                <div className = "form-type-box">
                    <label>Address</label>
                </div>
                <div className = "form-type-box">
                    <input
                        className = "type-box-type-input"
                        type = "text"
                        value = { address }
                        onChange = { e => setAddress(e.target.value) }
                    />
                </div>
            </div>
            <div className = "createClient-form-type">
                <div className = "form-type-box">
                    <label style = {{ width: "100%" }}>Do you want to include your address on your brandings?</label>
                </div>
                {
                    includeAddresses.map((item: radioType) => {
                        return <div className = "form-package-box" key = { item.id } onClick = {() => handleChange(item)}>
                            <input
                                className = "packageOption"
                                type = "radio"
                                checked = { item.active }
                                name = { "include Address" }
                            />
                            <label>{ item.title }</label>
                        </div>
                    })
                }
            </div>
        </div>
    )
}

export default Address
